import { GenIcon } from '../helpers/IconBase.es.js';

const PbNavigationCurvedFilled = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M0 12C0 5.37258 5.37258 0 12 0H24V24H12C5.37258 24 0 18.6274 0 12Z",
          fill: "#4B4B4B"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M14.3335 7.3335L9.66683 12.0002L14.3335 16.6668",
          stroke: "#8E8E8E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};

export { PbNavigationCurvedFilled };
